import React, { useCallback, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { cn } from '../../utils/cn';
interface AppLayoutProps {
  children: React.ReactNode;
}
export function AppLayout({
  children
}: AppLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen(prev => !prev);
  }, []);
  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev: boolean) => {
      const newState = !prev;
      localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
      return newState;
    });
  }, []);
  return <div className="min-h-screen bg-slate-50" data-id="element-140">
      <Header onToggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} data-id="element-141" />

      <div className="flex pt-16" data-id="element-142">
        <Sidebar isOpen={isSidebarOpen} isCollapsed={isCollapsed} onToggleCollapse={toggleCollapse} data-id="element-143" />

        <main id="main-content" className={cn('flex-1 px-4 sm:px-6 lg:px-8 py-6', isSidebarOpen ? isCollapsed ? 'ml-20' : 'ml-64' : 'ml-0')} data-id="element-144">
          {children}
        </main>
      </div>
    </div>;
}